import {SQFTResourceController} from "./SQFTResourceController";
import Spacer from "../../core/shapes/spacer";
import {WORKSPACE_RESOURCES} from "../../../../constants";

export class SpacersController extends SQFTResourceController {
  isJustCreated = false;

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.spacers;
  }

  setIsJustCreated(value) {
    this.isJustCreated = value
  }

  createSpacer(point1, point2, pos) {
    if (!this.isNotCreatedSpacerExist()) {
      this.addResource(new Spacer([point1, point2], pos));
    }
  }

  /**
  * Used to skip mouse up in workspace events
  **/
  isNotCreatedSpacerExist() {
    const resources = this.getResources();
    return resources.some(spacer => !spacer.getIsCreated())
  }
}

